// src/accordions.js
import $ from "jquery";
var accordions_default = () => {
  const ACCORDION_CONTAINER = '[data-behavior~="accordion"]';
  const RADIO_ACCORDION_CONTAINER = '[data-behavior~="radio-accordion"]';
  const ACCORDION_HEADING = '[data-behavior~="accordion-heading"]';
  const ACCORDION_CARET = '[data-behavior~="accordion-caret"]';
  const ACCORDION_CONTENT = '[data-behavior~="accordion-content"]';
  const ACCORDION_DURATION = 200;
  const assignAccordionAttrs = function() {
    $(ACCORDION_HEADING).each(function(i) {
      $(this).attr({
        id: `accordion-heading-${i}`,
        "aria-controls": `accordion-content-${i}`
      });
    });
    $(ACCORDION_CONTENT).each(function(i) {
      $(this).attr({
        id: `accordion-content-${i}`,
        "aria-labelledby": `accordion-heading-${i}`
      });
    });
  };
  const accordionClickHandlers = function() {
    return [ACCORDION_CARET, ACCORDION_HEADING].map(function(selector) {
      return `${ACCORDION_CONTAINER} ${selector}`;
    }).join(", ");
  };
  const radioAccordionClickHandlers = function() {
    return [ACCORDION_CARET, ACCORDION_HEADING].map(function(selector) {
      return `${RADIO_ACCORDION_CONTAINER} ${selector}`;
    }).join(", ");
  };
  const updateAriaAttributes = function(accordionContainer) {
    const accordionContent = accordionContainer.find(ACCORDION_CONTENT);
    const accordionButton = accordionContainer.find('[role="button"]');
    if (accordionButton.attr("aria-expanded") === "true") {
      accordionButton.attr("aria-expanded", "false");
      accordionContent.attr("aria-hidden", "true");
    } else {
      accordionButton.attr("aria-expanded", "true");
      accordionContent.attr("aria-hidden", "false");
    }
  };
  const collapseSiblingAccordionContainers = function(accordionContainer) {
    $.each(
      accordionContainer.siblings(RADIO_ACCORDION_CONTAINER),
      function(_, siblingAccordionContainer) {
        const $siblingAccordionContainer = $(siblingAccordionContainer);
        $siblingAccordionContainer.find(ACCORDION_CONTENT).slideUp(ACCORDION_DURATION).attr("aria-hidden", "true");
        $siblingAccordionContainer.removeClass("is-expanded");
        $siblingAccordionContainer.find(`${ACCORDION_CARET} .sc-Icon`).removeClass("is-expanded");
        $siblingAccordionContainer.find('[role="button"]').attr("aria-expanded", "false");
      }
    );
  };
  const toggleAccordion = function(accordionContainer, useRadioBehavior) {
    accordionContainer.find(ACCORDION_CONTENT).slideToggle(ACCORDION_DURATION);
    accordionContainer.toggleClass("is-expanded");
    accordionContainer.find(`${ACCORDION_CARET} .sc-Icon`).toggleClass("is-expanded");
    updateAriaAttributes(accordionContainer);
    if (useRadioBehavior) {
      collapseSiblingAccordionContainers(accordionContainer);
    }
  };
  const handleAccordionClick = function(e) {
    if ($(e.target).data("noToggle")) {
      return;
    }
    toggleAccordion($(e.currentTarget).closest(ACCORDION_CONTAINER));
  };
  const handleRadioAccordionClick = function(e) {
    if ($(e.target).data("noToggle")) {
      return;
    }
    toggleAccordion(
      $(e.currentTarget).closest(RADIO_ACCORDION_CONTAINER),
      true
    );
  };
  const isEnterKeydown = function(e) {
    return e.code === "Enter" || e.keyCode === 13;
  };
  const isSpaceKeydown = function(e) {
    return e.code === "Space" || e.keyCode === 32;
  };
  const handleKeyboardInteraction = function(e) {
    if (isEnterKeydown(e) || isSpaceKeydown(e)) {
      e.preventDefault();
      toggleAccordion($(e.currentTarget).closest(ACCORDION_CONTAINER));
    }
  };
  const handleRadioKeyboardInteraction = function(e) {
    if (isEnterKeydown(e) || isSpaceKeydown(e)) {
      e.preventDefault();
      toggleAccordion(
        $(e.currentTarget).closest(RADIO_ACCORDION_CONTAINER),
        true
      );
    }
  };
  $(document).ready(function() {
    assignAccordionAttrs();
  });
  $(document).on("click", accordionClickHandlers(), handleAccordionClick);
  $(document).on(
    "click",
    radioAccordionClickHandlers(),
    handleRadioAccordionClick
  );
  $(document).on(
    "keydown",
    `${ACCORDION_CONTAINER} ${ACCORDION_HEADING}`,
    handleKeyboardInteraction
  );
  $(document).on(
    "keydown",
    `${RADIO_ACCORDION_CONTAINER} ${ACCORDION_HEADING}`,
    handleRadioKeyboardInteraction
  );
};

// src/action_menu.js
import $2 from "jquery";
var action_menu_default = () => {
  const CLICK_TARGET_SELECTOR = '[data-behavior~="action-menu"] .DropdownInput-fakeInput, [data-behavior="action-menu"] [data-behavior="action-menu-click-target"]';
  let globalRelatedTarget;
  let keyboardSelectedIndex;
  let numItems;
  const setGlobalRelatedTarget = function(e) {
    globalRelatedTarget = e.target;
  };
  const isEnterKeydown = function(e) {
    return e.code === "Enter" || e.keyCode === 13;
  };
  const isSpaceKeydown = function(e) {
    return e.code === "Space" || e.keyCode === 32;
  };
  const isDownArrowKeydown = function(e) {
    return e.code === "Down" || e.keyCode === 40;
  };
  const isUpArrowKeydown = function(e) {
    return e.code === "Up" || e.keyCode === 38;
  };
  const isEscKeydown = function(e) {
    return e.code === "Esc" || e.keyCode === 27;
  };
  const isEndKeydown = function(e) {
    return e.code === "End" || e.keyCode === 35;
  };
  const isHomeKeydown = function(e) {
    return e.code === "Home" || e.keyCode === 36;
  };
  const openMenu = function($actionMenu) {
    $actionMenu.addClass("is-open");
    $2(document).on("mousedown", setGlobalRelatedTarget);
    $actionMenu.find(".DropdownInput-options").focus();
  };
  const closeMenu = function($actionMenu) {
    $actionMenu.removeClass("is-open");
    $2(document).off("mousedown", setGlobalRelatedTarget);
  };
  const toggleMenu = function(e) {
    const $actionMenu = $2(e.target).closest(".DropdownInput");
    const $otherMenus = $2(".DropdownInput").not($actionMenu);
    if (!$actionMenu.hasClass("is-open")) {
      openMenu($actionMenu);
      $otherMenus.removeClass("is-open");
    } else {
      closeMenu($actionMenu);
    }
    e.stopPropagation();
  };
  const optionsBlurEvent = function(e) {
    const $actionMenu = $2(this).closest(".DropdownInput");
    const $options = $actionMenu.find(".DropdownInput-options");
    const relatedTarget = e.relatedTarget || globalRelatedTarget;
    globalRelatedTarget = null;
    const optionsContainsTarget = relatedTarget && $2.contains($options[0], relatedTarget);
    const relatedTargetIsClickTarget = relatedTarget && ($2(relatedTarget).is(CLICK_TARGET_SELECTOR) || $2(relatedTarget).parents(CLICK_TARGET_SELECTOR).length !== 0);
    const hasClickedOutsideActionMenu = !(relatedTargetIsClickTarget || optionsContainsTarget);
    if (hasClickedOutsideActionMenu) {
      closeMenu($actionMenu);
    }
  };
  const actionClicked = function(e) {
    var $actionMenu = $2(this).closest(".DropdownInput");
    closeMenu($actionMenu);
    e.stopPropagation();
  };
  const handleKeyboardInteraction = function(e) {
    let $actionMenu;
    if (isEnterKeydown(e) || isSpaceKeydown(e) || isDownArrowKeydown(e)) {
      e.preventDefault();
      toggleMenu(e);
      $actionMenu = $2(e.target).closest(".DropdownInput");
      numItems = $actionMenu.find("a").length;
      keyboardSelectedIndex = 0;
      $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
    } else if (isUpArrowKeydown(e)) {
      e.preventDefault();
      toggleMenu(e);
      $actionMenu = $2(e.target).closest(".DropdownInput");
      numItems = $actionMenu.find("a").length;
      keyboardSelectedIndex = numItems - 1;
      $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
    }
  };
  const findItemMatchingKey = function(key, $actionMenu) {
    let count = keyboardSelectedIndex === numItems - 1 ? 0 : keyboardSelectedIndex + 1;
    while (count !== keyboardSelectedIndex) {
      const firstChar = $actionMenu.find(`a:eq(${count})`).text().charAt(0);
      if (firstChar.toLowerCase() === key.toLowerCase()) {
        keyboardSelectedIndex = count;
        $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
        break;
      }
      count = count === numItems - 1 ? 0 : count + 1;
    }
  };
  const actionKeyPressed = function(e) {
    const $actionMenu = $2(this).closest(".DropdownInput");
    if (isDownArrowKeydown(e)) {
      keyboardSelectedIndex = keyboardSelectedIndex === numItems - 1 ? 0 : keyboardSelectedIndex + 1;
      $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
    } else if (isUpArrowKeydown(e)) {
      keyboardSelectedIndex = keyboardSelectedIndex === 0 ? numItems - 1 : keyboardSelectedIndex - 1;
      $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
    } else if (isHomeKeydown(e)) {
      keyboardSelectedIndex = 0;
      $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
    } else if (isEndKeydown(e)) {
      keyboardSelectedIndex = numItems - 1;
      $actionMenu.find(`a:eq(${keyboardSelectedIndex})`).focus();
    } else if (isEscKeydown(e)) {
      closeMenu($actionMenu);
      $actionMenu.find("button").focus();
    } else if (isEnterKeydown(e)) {
      closeMenu($actionMenu);
    } else {
      findItemMatchingKey(e.key.toLowerCase(), $actionMenu);
    }
    if (!isEnterKeydown(e)) {
      e.preventDefault();
    }
  };
  $2(document).on("click", CLICK_TARGET_SELECTOR, toggleMenu);
  $2(document).on(
    "click",
    '[data-behavior~="action-menu"] .DropdownInput-options li',
    actionClicked
  );
  $2(document).on("keydown", CLICK_TARGET_SELECTOR, handleKeyboardInteraction);
  $2(document).on(
    "keydown",
    '[data-behavior~="action-menu"] .DropdownInput-options li',
    actionKeyPressed
  );
  $2(document).on(
    "blur",
    '[data-behavior~="action-menu"] .DropdownInput-options',
    optionsBlurEvent
  );
};

// src/aria_attributes.js
import $3 from "jquery";
var aria_attributes_default = () => {
  $3.fn.addAriaAttributes = function() {
    const $inputs = $3("form :input");
    $inputs.each(function() {
      const $this = $3(this);
      const $inputWrapper = $this.parent(
        ".input-wrapper[data-behavior-add-aria-attributes='true']"
      );
      const $hint = $inputWrapper.siblings(".hint");
      let ariaDescribedBy = "";
      if ($hint.length > 0) {
        const hintId = `${this.id}_hint`;
        $hint.attr("id", hintId);
        ariaDescribedBy += ` ${hintId}`;
      }
      const $validationError = $inputWrapper.siblings(".validation");
      if ($validationError.length > 0) {
        const validationId = `${this.id}_error`;
        $validationError.attr("id", validationId);
        ariaDescribedBy += ` ${validationId}`;
      }
      if (ariaDescribedBy.length > 0) {
        $this.attr("aria-describedby", ariaDescribedBy.trim());
      }
    });
  };
  $3(document).on("ready", $3.fn.addAriaAttributes);
};

// src/autocomplete.js
import $4 from "jquery";
var autocomplete_default = () => {
  function debounce(fn, delay) {
    let debounceTimer;
    return function(...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(
        function() {
          fn.apply(this, args);
        }.bind(this),
        delay
      );
    };
  }
  const InputSearch = function(el) {
    this.$el = $4(el).closest(".input-search");
    this.data = this.$el.data() || {};
    this.field = this.data.field;
    this.fieldSearch = this.data.fieldSearch || `${this.field}-search`;
    this.emptyOption = $4.extend({ text: "No matches" }, this.data.emptyOption);
    this.onOptionSelected = this.data.onOptionSelected;
    this.$input = this.$el.find(`input[name="${this.field}"]`);
    this.$options = this.$el.find(".select-options ul");
    if (this.onOptionSelected) {
      this.$input.on(
        "change",
        { action: this.onOptionSelected },
        this.onChange
      );
    }
    this.$el.find("input").on("keyup", debounce(this.onKeyup.bind(this), 200));
    this.$el.find("input").on("keydown", function(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
      return true;
    });
    $4(this.$el).on("click", this.onClick.bind(this));
    $4(document).on("click", this.onClick.bind(this));
    this.$el.addClass("open active empty");
  };
  InputSearch.prototype.search = function(query) {
    if (this.pendingRequest) {
      this.pendingRequest.abort();
    }
    this.pendingRequest = $4.ajax({
      url: this.data.sourceEndpoint,
      data: { query },
      method: "GET"
    }).always(
      function(data) {
        this.updateOptions(data);
      }.bind(this)
    );
  };
  InputSearch.prototype.updateOptions = function(options) {
    this.$options.empty();
    if (options && options.length) {
      this.currentOptions = {};
      $4.each(
        options,
        function(_index, option) {
          this.currentOptions[option.value] = option;
          this.$options.append(option.html);
        }.bind(this)
      );
    } else if (this.emptyOption.path) {
      const extraAttributes = this.emptyOption.remote ? { "data-remote": true } : {};
      const $option = $4("<a />", {
        href: this.emptyOption.path,
        ...extraAttributes
      }).html($4("<li />", { text: this.emptyOption.text }));
      this.$options.append($option);
    } else {
      const $option = $4("<li />", {
        class: "empty",
        text: this.emptyOption.text
      });
      this.$options.append($option);
    }
  };
  InputSearch.prototype.onKeyup = function(e) {
    this.search($4(e.target).val());
    this.$el.toggleClass("empty", !$4(e.target).val());
  };
  InputSearch.prototype.setValue = function(val) {
    if (this.currentOptions[val]) {
      this.$el.trigger("input_search:value:set", this.currentOptions[val]);
    }
    this.$input.val(val).trigger("change");
    this.$el.find(`input[name="${this.fieldSearch}"]`).val("");
    this.$el.removeClass("open active");
  };
  InputSearch.prototype.onClick = function(e) {
    e.stopPropagation();
    if ($4(e.target).is(`input[name="${this.fieldSearch}"]`)) {
      this.$el.addClass("open active");
    } else if ($4(e.target).is('[data-value]:not([data-behavior="input-search"])')) {
      e.preventDefault();
      this.setValue($4(e.target).data("value"));
    } else {
      this.$el.removeClass("open active");
    }
  };
  InputSearch.prototype.onChange = function(e) {
    if (e.data.action === "submit") {
      $4(e.target.form).submit();
    }
  };
  $4(document).on("focus", '[data-behavior="input-search"] input', function(e) {
    if (!$4(this).data("instance")) {
      $4(this).data("instance", new InputSearch(this));
      $4(this).trigger("click");
    }
  });
};

// src/base_inputs.js
import $5 from "jquery";
var base_inputs_default = () => {
  $5(document).on("focus", '[data-behavior="input"]', function(e) {
    $5(this).addClass("active");
  });
  $5(document).on("blur", '[data-behavior="input"]', function(e) {
    $5(this).removeClass("active");
  });
};

// src/checkbox_select.js
import $6 from "jquery";
var checkbox_select_default = () => {
  const CLICK_TARGET_SELECTOR = '[data-behavior~="checkbox-dropdown"] .DropdownInput-fakeInput';
  let globalRelatedTarget;
  const setGlobalRelatedTarget = function(e) {
    globalRelatedTarget = e.target;
  };
  const openMenu = function($dropdown) {
    $dropdown.addClass("is-open");
    $6(document).on("mousedown", setGlobalRelatedTarget);
    $dropdown.find(".DropdownInput-options").focus();
  };
  const closeMenu = function($dropdown) {
    $dropdown.removeClass("is-open");
    $6(document).off("mousedown", setGlobalRelatedTarget);
  };
  const toggleMenu = function() {
    var $dropdown = $6(this).closest(".DropdownInput");
    if (!$dropdown.hasClass("is-open")) {
      openMenu($dropdown);
    } else {
      closeMenu($dropdown);
    }
  };
  const optionsBlurEvent = function(e) {
    const $dropdown = $6(this).closest(".DropdownInput");
    const $options = $dropdown.find(".DropdownInput-options");
    const relatedTarget = e.relatedTarget || globalRelatedTarget;
    globalRelatedTarget = null;
    const optionsContainsTarget = relatedTarget && $6.contains($options[0], relatedTarget);
    const relatedTargetIsClickTarget = relatedTarget && ($6(relatedTarget).is(CLICK_TARGET_SELECTOR) || $6(relatedTarget).parents(CLICK_TARGET_SELECTOR).length !== 0);
    const hasClickedOutsideDropdown = !(relatedTargetIsClickTarget || optionsContainsTarget);
    if (relatedTarget && hasClickedOutsideDropdown) {
      closeMenu($dropdown);
    } else {
      $dropdown.find(".DropdownInput-options").focus();
    }
  };
  const updateSelectCheckboxPlaceholder = function() {
    const $dropdown = $6(this).closest(".DropdownInput");
    const $checked = $dropdown.find("input:checked");
    const $selectedDisplay = $dropdown.find(
      ".DropdownInput-fakeInput .DropdownInput-selectedLabel"
    );
    const label = $dropdown.siblings("label").text();
    let placeholder = `Add ${label}`;
    if ($checked.length === 1) {
      placeholder = $checked.first().siblings("label").text();
    } else if ($checked.length > 1) {
      placeholder = `${$checked.length} ${label}`;
    }
    $selectedDisplay.text(placeholder);
  };
  $6(document).on("click", CLICK_TARGET_SELECTOR, toggleMenu);
  $6(document).on(
    "blur",
    '[data-behavior~="checkbox-dropdown"] .DropdownInput-options',
    optionsBlurEvent
  );
  $6(document).on(
    "change",
    '[data-behavior~="checkbox-dropdown"] input[type="checkbox"]',
    updateSelectCheckboxPlaceholder
  );
};

// src/checkboxes.js
import $7 from "jquery";
var checkboxes_default = () => {
  $7(document).on("click", '[data-behavior~="checkbox"]', function(e) {
    var $button = $7(this);
    var $input = $button.find("input[type=checkbox]");
    if ($7(e.target).is($input)) {
      return;
    }
    $input.prop("checked", !$input.prop("checked")).change();
  });
};

// src/datepicker.js
import $8 from "jquery";
import moment from "moment";
import Pikaday from "pikaday";
var datepicker_default = () => {
  $8.fn.datepicker = function() {
    this.each(function() {
      var pika = new Pikaday({
        field: this,
        format: $8(this).data("format"),
        maxDate: $8(this).data("maxDate"),
        minDate: $8(this).data("minDate"),
        toString(date, format) {
          return moment(date).format(format);
        },
        parse(value, format) {
          const date = moment(value, format);
          return date && date.isValid() ? date.toDate() : null;
        },
        i18n: {
          previousMonth: "Previous Month",
          nextMonth: "Next Month",
          months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ],
          weekdays: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ],
          weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"]
        }
      });
      if ($8(this).data().inModal) {
        $8(pika.el).css("z-index", "10000000");
      }
    });
  };
};

// src/dropdowns.js
import $9 from "jquery";
var dropdowns_default = () => {
  const openDropdown = function() {
    var $inputDiv = $9(this).closest('[data-behavior="dropdown"]');
    $inputDiv.addClass("active open");
    $inputDiv.find(".select-options").focus();
  };
  const closeDropdown = function(e) {
    if ($9(e.target).is('[type="checkbox"]')) {
      return;
    }
    const $inputDiv = $9(this).closest('[data-behavior="dropdown"]');
    $inputDiv.removeClass("open");
    const isEmpty = $inputDiv.find("select").val() === "";
    $inputDiv.toggleClass("active", isEmpty);
  };
  const toggleDropdown = function(e) {
    e.preventDefault();
    const $inputDiv = $9(this).closest('[data-behavior="dropdown"]');
    if ($inputDiv.hasClass("open")) {
      closeDropdown.call(this, e);
    } else {
      openDropdown.call(this, e);
    }
  };
  const optionSelected = function() {
    if ($9(this).hasClass("input-check")) {
      $9(this).find('[type="checkbox"]').click();
    } else {
      const $inputDiv = $9(this).closest('[data-behavior="dropdown"]');
      const value = $9(this).data("value");
      $inputDiv.find("select").val(value).trigger("change", this);
    }
  };
  const selectChanged = function(_event, clickedElement) {
    const $inputDiv = $9(this).closest('[data-behavior="dropdown"]');
    let $option;
    if (clickedElement) {
      $option = $9(clickedElement);
    } else {
      const value = $9(this).val();
      $option = $inputDiv.find(`.select-options li[data-value="${value}"]`).first();
    }
    const label = $option.text();
    $inputDiv.find(".selectable").removeClass("selected");
    $option.addClass("selected");
    $inputDiv.find(".display-selected").html(`<span>${label}</span>`);
    $inputDiv.addClass("active").removeClass("open");
  };
  $9(document).on(
    "mousedown",
    '[data-behavior="dropdown"] .display-selected',
    toggleDropdown
  );
  $9(document).on(
    "blur focusout",
    '[data-behavior="dropdown"] .select-options',
    closeDropdown
  );
  $9(document).on(
    "click",
    '[data-behavior="dropdown"] .select-options li.selectable',
    optionSelected
  );
  $9(document).on("change", '[data-behavior="dropdown"] select', selectChanged);
};

// src/faq.js
import $10 from "jquery";
var faq_default = () => {
  const FAQ_CONTAINER = '[data-behavior~="sc-faq"]';
  const RADIO_FAQ_CONTAINER = '[data-behavior~="sc-radio-faq"]';
  const FAQ_TRIGGER = '[data-behavior~="sc-faq-trigger"]';
  const FAQ_QUESTION = '[data-behavior~="sc-faq-question"]';
  const FAQ_ANSWER = '[data-behavior~="sc-faq-answer"]';
  const FAQ_CARET = '[data-behavior~="sc-faq-caret"]';
  const FAQ_SLIDE_DURATION = 200;
  const assignQuestionAttrs = function() {
    $10(FAQ_QUESTION).each(function(i) {
      $10(this).attr({
        id: `faq-question-${i}`,
        "aria-controls": `faq-answer-${i}`
      });
    });
  };
  const assignAnswerAttrs = function() {
    $10(FAQ_ANSWER).each(function(i) {
      $10(this).attr({
        id: `faq-answer-${i}`,
        "aria-labelledby": `faq-question-${i}`,
        "aria-hidden": "true"
      });
    });
  };
  const faqClickHandlers = function() {
    return [FAQ_CARET, FAQ_QUESTION, FAQ_TRIGGER].map(function(selector) {
      return `${FAQ_CONTAINER} ${selector}`;
    }).join(", ");
  };
  const radioFaqClickHandlers = function() {
    return [FAQ_CARET, FAQ_QUESTION, FAQ_TRIGGER].map(function(selector) {
      return `${RADIO_FAQ_CONTAINER} ${selector}`;
    }).join(", ");
  };
  const collapseSiblingFaqAnswers = function(faqContainer) {
    $10.each(
      faqContainer.siblings(RADIO_FAQ_CONTAINER),
      function(_, siblingFaqContainer) {
        const $siblingFaqContainer = $10(siblingFaqContainer);
        $siblingFaqContainer.find(FAQ_ANSWER).slideUp(FAQ_SLIDE_DURATION).attr("aria-hidden", "true");
        $siblingFaqContainer.removeClass("is-expanded");
        $siblingFaqContainer.find(`${FAQ_CARET} .sc-Icon`).removeClass("is-expanded");
        $siblingFaqContainer.find('[role="button"]').attr("aria-expanded", "false");
      }
    );
  };
  const updateAriaAttributes = function(faqContainer) {
    const faqAnswer = faqContainer.find(FAQ_ANSWER);
    const faqButton = faqContainer.find('[role="button"]');
    if (faqButton.attr("aria-expanded") === "true") {
      faqButton.attr("aria-expanded", "false");
      faqAnswer.attr("aria-hidden", "true");
    } else {
      faqButton.attr("aria-expanded", "true");
      faqAnswer.attr("aria-hidden", "false");
    }
  };
  const toggleAnswer = function(faqContainer, useRadioBehavior) {
    faqContainer.find(FAQ_ANSWER).slideToggle(FAQ_SLIDE_DURATION);
    faqContainer.toggleClass("is-expanded");
    faqContainer.find(`${FAQ_CARET} .sc-Icon`).toggleClass("is-expanded");
    updateAriaAttributes(faqContainer);
    if (useRadioBehavior) {
      collapseSiblingFaqAnswers(faqContainer);
    }
  };
  const handleFaqClick = function(e) {
    toggleAnswer($10(e.currentTarget).closest(FAQ_CONTAINER));
  };
  const handleRadioFaqClick = function(e) {
    toggleAnswer($10(e.currentTarget).closest(RADIO_FAQ_CONTAINER), true);
  };
  const isEnterKeydown = function(e) {
    return e.code === "Enter" || e.keyCode === 13;
  };
  const isSpaceKeydown = function(e) {
    return e.code === "Space" || e.keyCode === 32;
  };
  const handleKeyboardInteraction = function(e) {
    if (isEnterKeydown(e) || isSpaceKeydown(e)) {
      e.preventDefault();
      toggleAnswer($10(e.currentTarget).closest(FAQ_CONTAINER));
    }
  };
  const handleRadioKeyboardInteraction = function(e) {
    if (isEnterKeydown(e) || isSpaceKeydown(e)) {
      e.preventDefault();
      toggleAnswer($10(e.currentTarget).closest(RADIO_FAQ_CONTAINER), true);
    }
  };
  $10(document).ready(function() {
    assignQuestionAttrs();
    assignAnswerAttrs();
  });
  $10(document).on("click", faqClickHandlers(), handleFaqClick);
  $10(document).on("click", radioFaqClickHandlers(), handleRadioFaqClick);
  $10(document).on(
    "keydown",
    `${FAQ_CONTAINER} ${FAQ_QUESTION}`,
    handleKeyboardInteraction
  );
  $10(document).on(
    "keydown",
    `${RADIO_FAQ_CONTAINER} ${FAQ_QUESTION}`,
    handleRadioKeyboardInteraction
  );
};

// src/file_inputs.js
import $11 from "jquery";
var file_inputs_default = () => {
  $11(document).on("change", '[data-behavior="file-input"] input', function(e) {
    var $hiddenInput = $11(this);
    var labelValue = $hiddenInput.val().replace(/^.*\\/, "") || "Select a file";
    $hiddenInput.siblings(".filename").text(labelValue);
  });
};

// src/floating_layer.js
import $12 from "jquery";
import Popper from "popper.js";
var floating_layer_default = () => {
  const FLOATING_LAYER_REFERENCE = "[data-sc-floating-layer-reference]";
  function getFloatingLayer(referenceId) {
    return $12(
      `[data-sc-floating-layer-content][data-sc-floating-layer-content-refers-to="${referenceId}"]`
    );
  }
  $12(document).ready(function() {
    $12(FLOATING_LAYER_REFERENCE).each(function(_, element) {
      const referenceElement = $12(element);
      const floatingLayer = getFloatingLayer(
        referenceElement.data("sc-floating-layer-reference")
      );
      $12(referenceElement).on("click focus", function() {
        new Popper(referenceElement, floatingLayer);
        referenceElement.append(floatingLayer);
        floatingLayer.toggleClass("is-showing");
      });
    });
  });
};

// src/header_nav.js
import $13 from "jquery";
var header_nav_default = () => {
  const MAIN_NAV_LINK_CLASS = "sc-Nav-mainNavLink";
  const MAIN_NAV_LINK = `.${MAIN_NAV_LINK_CLASS}`;
  const MAIN_NAV_ITEM_WITH_CHILDREN = ".sc-Nav-mainNavItem--withChildren";
  const MAIN_NAV_ITEM_WITH_CHILDREN_LINK = `${MAIN_NAV_ITEM_WITH_CHILDREN} ${MAIN_NAV_LINK}`;
  const NAV_PANEL = ".sc-Nav-panel";
  const TRIGGER_CTA_DETAILED_MODE = ".sc-Nav-triggerCta--detailedMode";
  const TRIGGER_TEXT_DETAILED_MODE = ".sc-Nav-triggerText";
  const IS_OPEN = "is-open";
  const IS_EXPANDED = "is-expanded";
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints;
  let shouldSkipHandleMousedown = false;
  const isOpen = function(el) {
    return el.hasClass(IS_OPEN);
  };
  const actions = {
    open(el) {
      el.addClass(IS_OPEN);
      const childNavPanel = el.children(NAV_PANEL);
      childNavPanel.addClass(IS_EXPANDED);
    },
    close(el) {
      el.removeClass(IS_OPEN);
      const childNavPanel = el.children(NAV_PANEL);
      childNavPanel.removeClass(IS_EXPANDED);
    },
    toggle(el) {
      this.closeOtherMainNavItems(el);
      if (isOpen(el)) {
        this.close(el);
      } else {
        this.open(el);
      }
    },
    closeOtherMainNavItems(el) {
      const self = this;
      $13([MAIN_NAV_ITEM_WITH_CHILDREN, TRIGGER_CTA_DETAILED_MODE].join(",")).not(el).each(function() {
        self.close($13(this));
      });
    }
  };
  const handleMouseenter = function(e, cta) {
    const el = $13(e.target).closest(cta);
    actions.open(el);
  };
  const handleMouseleave = function(e, cta) {
    const el = $13(e.target).closest(cta);
    actions.close(el);
  };
  const handleMousedown = function(e, cta) {
    if (shouldSkipHandleMousedown) {
      shouldSkipHandleMousedown = false;
      return;
    }
    const el = $13(e.target).closest(cta);
    actions.toggle(el, e);
  };
  const handleTouchend = function(e, cta) {
    shouldSkipHandleMousedown = true;
    const el = $13(e.target).closest(cta);
    actions.toggle(el, e);
  };
  const addMainNavLinkHandlers = function(el, cta) {
    if (isTouchDevice) {
      el.addEventListener("touchend", function(e) {
        handleTouchend(e, cta);
      });
    }
    el.addEventListener("mousedown", function(e) {
      handleMousedown(e, cta);
    });
  };
  const addMainNavItemHandlers = function(el, cta) {
    if (!isTouchDevice) {
      el.addEventListener("mouseenter", function(e) {
        handleMouseenter(e, cta);
      });
      el.addEventListener("mouseleave", function(e) {
        handleMouseleave(e, cta);
      });
    }
  };
  const shortCircuitMainNavItemWithChildrenLinks = function() {
    $13(MAIN_NAV_ITEM_WITH_CHILDREN_LINK).each(function() {
      $13(this).replaceWith(
        `<span class="${$13(this).attr("class")}">${$13(this).text()}</span>`
      );
    });
  };
  $13(document).ready(function() {
    if (isTouchDevice) {
      shortCircuitMainNavItemWithChildrenLinks();
    }
    $13(MAIN_NAV_LINK).each(function() {
      addMainNavLinkHandlers(this, MAIN_NAV_ITEM_WITH_CHILDREN);
    });
    $13(MAIN_NAV_ITEM_WITH_CHILDREN).each(function() {
      addMainNavItemHandlers(this, MAIN_NAV_ITEM_WITH_CHILDREN);
    });
    $13(TRIGGER_CTA_DETAILED_MODE).each(function() {
      addMainNavItemHandlers(this, TRIGGER_CTA_DETAILED_MODE);
    });
    $13(TRIGGER_TEXT_DETAILED_MODE).each(function() {
      addMainNavLinkHandlers(this, TRIGGER_CTA_DETAILED_MODE);
    });
  });
};

// src/legacy_accordions.js
import $14 from "jquery";
var legacy_accordions_default = () => {
  const HIDDEN_CONTENT = '[data-behavior~="sc-hidden-content"]';
  const ACCORDION = '[data-behavior~="sc-accordion"]';
  const ACCORDION_LABEL = `${ACCORDION} .sc-ListItem-label`;
  const LABEL_ICON = "> .sc-ListItem-label .sc-ListItem-icon";
  const RADIO_ACCORDION = '[data-behavior~="sc-radio-accordion"]';
  const RADIO_ACCORDION_LABEL = `${RADIO_ACCORDION} .sc-ListItem-label`;
  const ACCORDION_DURATION = 200;
  const toggleAccordion = function(accordionElement) {
    accordionElement.find(HIDDEN_CONTENT).slideToggle(ACCORDION_DURATION);
    accordionElement.find(LABEL_ICON).toggleClass("is-expanded");
    accordionElement.toggleClass("is-expanded");
  };
  const unexpandAccordion = function(accordionElement) {
    accordionElement.find(HIDDEN_CONTENT).slideUp(ACCORDION_DURATION);
    accordionElement.find(LABEL_ICON).removeClass("is-expanded");
    accordionElement.removeClass("is-expanded");
  };
  $14(document).on("click", ACCORDION_LABEL, function(e) {
    if ($14(e.target).data("noToggle")) {
      return;
    }
    const accordionElement = $14(e.currentTarget).closest(ACCORDION);
    toggleAccordion(accordionElement);
  });
  $14(document).on("click", RADIO_ACCORDION_LABEL, function(e) {
    if ($14(e.target).data("noToggle")) {
      return;
    }
    const accordionElement = $14(e.currentTarget).closest(RADIO_ACCORDION);
    toggleAccordion(accordionElement);
    $14.each(
      accordionElement.siblings(RADIO_ACCORDION),
      function(_, siblingAccordionElement) {
        unexpandAccordion($14(siblingAccordionElement));
      }
    );
  });
};

// src/masks.js
import {
  createAutoCorrectedDatePipe,
  createNumberMask
} from "text-mask-addons";
import { maskInput } from "vanilla-text-mask";
var masks_default = () => {
  window.createMask = function(id, maskType) {
    var elem = document.getElementById(id);
    switch (maskType) {
      case "cents":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: [/\d/, /\d/]
        });
        break;
      case "currency":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: createNumberMask({
            prefix: "",
            allowDecimal: false
          })
        });
        break;
      case "currencyWithCents":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: createNumberMask({
            prefix: "",
            allowDecimal: true
          })
        });
        break;
      case "date":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
          pipe: createAutoCorrectedDatePipe("mm/dd/yyyy")
        });
        break;
      case "phoneNumber":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: [
            /[1-9]/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]
        });
        break;
      case "socialSecurityNumber":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: [
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]
        });
        break;
      case "zip":
        maskInput({
          inputElement: elem,
          guide: false,
          mask: [/\d/, /\d/, /\d/, /\d/, /\d/]
        });
        break;
      default:
        break;
    }
  };
};

// src/modal.js
import $15 from "jquery";
var modal_default = () => {
  const FOCUSABLE_ELEMENTS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable] ';
  function isEnterKeydown(e) {
    return e.code === "Enter" || e.keyCode === 13;
  }
  function isSpaceKeydown(e) {
    return e.code === "Space" || e.keyCode === 32;
  }
  function isSpacebarSelectableElement(e) {
    return e.target.tagName.toLowerCase() === "button" || e.target.getAttribute("role") === "button";
  }
  function isEligibleSpaceKeydown(e) {
    return isSpaceKeydown(e) && isSpacebarSelectableElement(e);
  }
  function isEscapeKeydown(e) {
    return e.code === "Escape" || e.keyCode === 27;
  }
  function isTabKeydown(e) {
    return e.code === "Tab" || e.keyCode === 9;
  }
  function isKeyboardCloseKey(e) {
    return isEnterKeydown(e) || isSpaceKeydown(e) || isEscapeKeydown(e);
  }
  function isSelectionInteraction(e) {
    return e.type === "click" || isEnterKeydown(e) || isEligibleSpaceKeydown(e);
  }
  let focusedElementBeforeModal;
  let $modal;
  function closeModal($target) {
    const $modalNearby = $target.closest(".is-open");
    $modalNearby.trigger("sc-Modal.close");
    $modalNearby.removeClass("is-open");
    $15("body").removeClass("u-overflowHidden");
    $15(document).off("keydown.modalEscape");
    if (focusedElementBeforeModal) focusedElementBeforeModal.focus();
  }
  function addTabKeydownListener($modalTarget, firstTabStop, lastTabStop) {
    $modalTarget.on("keydown", function(e) {
      if (isTabKeydown(e)) {
        if (e.shiftKey) {
          if (document.activeElement === firstTabStop) {
            e.preventDefault();
            lastTabStop.focus();
          }
        } else if (document.activeElement === lastTabStop) {
          e.preventDefault();
          firstTabStop.focus();
        }
      }
    });
  }
  function addEscapeKeydownListener($modalTarget) {
    $15(document).on("keydown.modalEscape", function(e) {
      if (isEscapeKeydown(e)) {
        closeModal($modalTarget);
      }
    });
  }
  $15(document).on("click keydown", "[data-sc-modal-target]", function(e) {
    if (e && isSelectionInteraction(e)) {
      e.preventDefault();
      focusedElementBeforeModal = $15(document.activeElement);
      const $modalNearby = $15($15(e.currentTarget).data("scModalTarget"));
      const focusableElements = Array.from(
        $modalNearby.find(FOCUSABLE_ELEMENTS)
      );
      const firstTabStop = focusableElements[0];
      const lastTabStop = focusableElements[focusableElements.length - 1];
      $modalNearby.addClass("is-open");
      $modalNearby.trigger("sc-Modal.open");
      $15("body").addClass("u-overflowHidden");
      if (firstTabStop) firstTabStop.focus();
      addTabKeydownListener($modalNearby, firstTabStop, lastTabStop);
      addEscapeKeydownListener($modalNearby);
    }
  });
  $15(document).on(
    "sc-Modal.auto-open",
    "[data-sc-modal-auto-open]",
    function() {
      $modal = $15(".sc-Modal.is-open");
      if ($modal.length > 0) {
        const focusableElements = Array.from($modal.find(FOCUSABLE_ELEMENTS));
        const firstTabStop = focusableElements[0];
        const lastTabStop = focusableElements[focusableElements.length - 1];
        $15("body").addClass("u-overflowHidden");
        if (firstTabStop) firstTabStop.focus();
        addTabKeydownListener($modal, firstTabStop, lastTabStop);
        addEscapeKeydownListener($modal);
      }
    }
  );
  $15(document).on("click", ".sc-Modal", function(e) {
    const $target = $15(e.target);
    if ($target.closest(".sc-Modal-container").length === 0) {
      e.preventDefault();
      closeModal($target);
    }
  });
  $15(document).on(
    "click keydown",
    ".sc-Modal-close, [data-sc-modal-close]",
    function(e) {
      if (e.type === "click" || isKeyboardCloseKey(e)) {
        e.preventDefault();
        closeModal($15(e.target));
      }
    }
  );
};

// src/radio_toggle.js
import $16 from "jquery";
var radio_toggle_default = () => {
  var selectRadioButton = function(e) {
    var $button = $16(this);
    var $radioSet = $button.closest('[data-behavior~="radio"]');
    var $hiddenInput = $button.find("input");
    var name = $hiddenInput.attr("name");
    var $buttonsInGroup = $radioSet.find(`input[name="${name}"]`).closest(".RadioToggleGroup-toggle");
    $hiddenInput.prop("checked", true).change();
    $buttonsInGroup.removeClass("selected");
    $button.addClass("selected");
  };
  $16(document).on(
    "click",
    '[data-behavior~="radio"] .RadioToggleGroup-toggle',
    selectRadioButton
  );
};

// src/toggle_class.js
import $17 from "jquery";
var toggle_class_default = () => {
  const SELECTION_INTERACTION_TYPES = "click keydown";
  const isEnterKeydown = function(e) {
    return e.type === "keydown" && (e.code === "Enter" || e.keyCode === 13);
  };
  const isSpaceKeydown = function(e) {
    return e.type === "keydown" && (e.code === "Space" || e.keyCode === 32);
  };
  const isSpacebarSelectableElement = function(e) {
    return e.target.tagName.toLowerCase() === "button" || e.target.getAttribute("role") === "button";
  };
  const isEligibleSpaceKeydown = function(e) {
    return isSpaceKeydown(e) && isSpacebarSelectableElement(e);
  };
  const isSelectionInteraction = function(e) {
    return e.type === "click" || isEnterKeydown(e) || isEligibleSpaceKeydown(e);
  };
  $17(document).on(
    SELECTION_INTERACTION_TYPES,
    "[data-behavior-toggle-class]",
    function(e) {
      if (isSelectionInteraction(e)) {
        if ($17(e.target).data("noToggle")) {
          return;
        }
        if ($17(e.target).data("preventDefault") !== false) {
          e.preventDefault();
        }
        const className = $17(this).data("behavior-toggle-class");
        const closestTarget = $17(this).data("closest");
        const findTarget = $17(this).data("find");
        const target = $17(this).data("toggle-target");
        if (!target) {
          $17(this).toggleClass(className);
        } else if (closestTarget) {
          $17(this).closest(target).toggleClass(className);
        } else if (findTarget) {
          $17(this).find(target).toggleClass(className);
        } else {
          $17(target).toggleClass(className);
        }
      }
    }
  );
};

// src/tooltips.js
import $18 from "jquery";
import Tooltip from "tooltip.js";
var tooltips_default = () => {
  const UNINITIALIZED_TOOLTIP = "[data-sc-tooltip]:not([data-sc-tooltip-processed])";
  const TOOLTIP_TARGET_SELECTOR = "[data-sc-tooltip]";
  $18.fn.scTooltips = function() {
    $18(document).find(UNINITIALIZED_TOOLTIP).each(function(_, element) {
      const referenceElement = $18(element);
      const text = referenceElement.data("sc-tooltip");
      const placement = referenceElement.data("sc-tooltip-placement") || "top";
      const container = referenceElement.data("sc-tooltip-container") || false;
      new Tooltip(referenceElement, {
        template: '<div class="tooltip sc-Tooltip" role="tooltip"><div class="sc-Tooltip-content tooltip-inner"></div></div>',
        title: text,
        html: true,
        container,
        placement
      });
      referenceElement.attr("data-sc-tooltip-processed", true);
    });
  };
  $18(document).ready(function() {
    if ($18.fn.scTooltips) $18(this).scTooltips();
  });
  $18(document).ajaxSuccess(function() {
    if ($18.fn.scTooltips) $18(this).scTooltips();
  });
  $18(document).on("turbo:load", function() {
    if ($18.fn.scTooltips) $18(this).scTooltips();
  });
  const isEscKeydown = function(e) {
    return e.code === "Esc" || e.keyCode === 27;
  };
  const handleKeyboardInteraction = function(e) {
    if (isEscKeydown(e)) {
      const $tooltip = $18(".tooltip");
      $tooltip.attr("aria-hidden", "true");
      $tooltip.css("visibility", "hidden");
      e.preventDefault();
    }
  };
  const handleTouchEvent = () => {
    if ($18.fn.scTooltips) {
      const $tooltip = $18(".tooltip");
      const isHidden = $tooltip.attr("aria-hidden");
      if (isHidden === "true" || !isHidden) {
        $tooltip.attr("aria-hidden", "false");
        $tooltip.css("visibility", "visible");
      } else {
        $tooltip.attr("aria-hidden", "true");
        $tooltip.css("visibility", "hidden");
      }
    }
  };
  $18(document).on("touchstart", TOOLTIP_TARGET_SELECTOR, handleTouchEvent);
  $18(document).on("keydown", TOOLTIP_TARGET_SELECTOR, handleKeyboardInteraction);
};
export {
  accordions_default as accordions,
  action_menu_default as actionMenu,
  aria_attributes_default as ariaAttributes,
  autocomplete_default as autocomplete,
  base_inputs_default as baseInputs,
  checkbox_select_default as checkboxSelect,
  checkboxes_default as checkboxes,
  datepicker_default as datepicker,
  dropdowns_default as dropdowns,
  faq_default as faqs,
  file_inputs_default as fileInputs,
  floating_layer_default as floatingLayer,
  header_nav_default as headerNav,
  legacy_accordions_default as legacyAccordions,
  masks_default as masks,
  modal_default as modals,
  radio_toggle_default as radioToggle,
  toggle_class_default as toggleClass,
  tooltips_default as tooltips
};
//# sourceMappingURL=index.js.map